import { render } from "./SidebarV2.vue?vue&type=template&id=2b9f7ea4"
import script from "./SidebarV2.vue?vue&type=script&lang=js"
export * from "./SidebarV2.vue?vue&type=script&lang=js"

import "./SidebarV2.vue?vue&type=style&index=0&id=2b9f7ea4&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__